import { useExtractColorFromImagesMutation } from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { toggleUpdatingField } from '@/lib/utils/updating-fields';
import { productsMapState } from '@/states/products.state';
import { useSetAtom } from 'jotai';

export const useExtractColorFromImages = (dealId: string) => {
  const [extractColorFromImagesMutation, { loading, error }] =
    useExtractColorFromImagesMutation();
  const setProductsMap = useSetAtom(productsMapState);

  const extractColorFromImages = async (dealItemsIds: string[]) => {
    const idsSet = new Set(dealItemsIds);
    const applyUpdatingField = (add: boolean) =>
      setProductsMap((prev) =>
        toggleUpdatingField(prev, idsSet, 'options', add)
      );

    applyUpdatingField(true);
    trackEvent('AI_EXTRACT_COLOR_STARTED', {
      dealId,
      itemCount: dealItemsIds.length,
    });
    try {
      const result = await extractColorFromImagesMutation({
        variables: { dealId, dealItemsIds },
      });
      trackEvent('AI_EXTRACT_COLOR_COMPLETED', {
        dealId,
        itemCount: dealItemsIds.length,
      });
      return result;
    } catch (err) {
      applyUpdatingField(false);
      throw err;
    }
  };

  return {
    extractColorFromImages,
    loading,
    error,
  };
};
